<template>
  <a-card :bordered="false" title="发送记录">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="手机号" v-bind="searchItemLayout">
            <a-input placeholder="请输入手机号" v-model="queryParams.mobile"/>
          </a-form-item>
          <a-form-item style="margin-left:5%;">
            <a-button type="primary" @click="onSearch">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="preSmsUrl"
      params-path="sms/getSmsRecordList"
    >
    <span slot="index" slot-scope="rowItem">
      {{ rowItem.index + 1 }}
    </span>
      <span slot="smsContent" slot-scope="rowItem">
      {{ rowItem.text }}
    </span>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'SendRecord',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '短信内容',
          dataIndex: 'smsContent',
          width: '50%',
          scopedSlots: { customRender: 'smsContent' }
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '总条数',
          dataIndex: 'sendCount'
        },
        {
          title: '发送时间',
          dataIndex: 'successTime'
        },
        {
          title: '状态',
          dataIndex: 'status'
        }
      ]
    }
  },

  created() {
  },
  mounted() {
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
    }
  }

}
</script>
<style scoped>
</style>